<template>
  <validation-observer ref="refFormObserver" #default="{ handleSubmit }">
    <div class="d-flex justify-content-end">
      <b-button
        variant="outline-primary"
        size="sm"
        @click="$emit('add-from-template')"
      >
        {{ $t('unit.import_from_template') }}
      </b-button>
    </div>
    <b-form
      class="mt-1"
      @submit.prevent="handleSubmit(onSubmit)"
      @reset.prevent="resetForm"
    >
      <b-row class="mx-0 px-0">

        <b-col cols="5" class="pl-0">
          <!-- Key -->
          <validation-provider
            #default="validationContext"
            :name="$t('unit.key')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('unit.key')"
              label-for="description"
            >
              <b-form-input
                id="key"
                v-model="item.key"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="5" class="pl-0">
          <!-- Key -->
          <validation-provider
            #default="validationContext"
            :name="$t('unit.value')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('unit.value')"
              label-for="value"
            >
              <b-form-input
                id="value"
                v-model="item.value"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="2" class="pl-0">
          <div class="form-group mb-0">
            <label class="d-block">&nbsp;</label>
            <b-button
              type="submit"
              variant="primary"
            >
              {{ titleButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { computed } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  props: {
    currentIndexItem: {
      type: Number
    },
    item: {
      type: Object
    },
    propItemData: {
      type: Object
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  setup (props, { emit }) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    const { refFormObserver, getValidationState,resetForm } = formValidation();

    //COMPUTED
    const titleButton = computed(() => props.item.id ? t('actions.edit') : t('actions.add'));

    //METHODS
    const onSubmit = () => {
      if (props.item.id || props.item.exists) {
        props.propItemData.additional_info[props.currentIndexItem] = props.item;
      } else {
        props.propItemData.additional_info.push({
          ...props.item,
          exists: true
        });
      }

      refFormObserver.value.reset();
      emit('clean-item');
    }

    return {
      required,
      refFormObserver,

      titleButton,

      getValidationState,
      resetForm,
      onSubmit
    }
  }
}
</script>
